import type { RatingFilterDto, RatingValueDto } from '../filters/FiltersMappings';
import { IncomingFeedbackDtoFilters } from '../filters/FiltersMappings';
import type { RatingFilterValue } from '../../../components/IncomingFeedback/ResponsesFilters/RatingFilter/RatingFilterType';
import {
  areAllRatingsIncluded,
  RATING_TYPE,
} from '../../../components/IncomingFeedback/ResponsesFilters/RatingFilter/RatingFilterType';

function ratingValueConverter(modelValue: RATING_TYPE[]): RatingValueDto[] {
  return modelValue.map((r) => {
    switch (r) {
      case RATING_TYPE.HATE:
        return 0;
      case RATING_TYPE.DISLIKE:
        return 1;
      case RATING_TYPE.NEUTRAL:
        return 2;
      case RATING_TYPE.LIKE:
        return 3;
      case RATING_TYPE.LOVE:
        return 4;
    }
  });
}

export function ratingFilterConverter(filterValue: RatingFilterValue): RatingFilterDto | undefined {
  if (!filterValue || filterValue.length === 0 || areAllRatingsIncluded(filterValue)) {
    return undefined;
  }

  return {
    type: IncomingFeedbackDtoFilters.RATING,
    values: ratingValueConverter(filterValue),
  };
}
